export default __webpack_public_path__ + "static/media/SourceSansProBold.cf278eaf.ttf";